import React from 'react';
import { connect } from 'react-redux';
import { startSpinToWinLimitFlow } from '../../../redux/actions';
import { spinToWinLimitSelector } from '../../../redux/selectors/featureActionsSelector';
import Portlet from '../Portlet';

const mapStateToProps = state => ({
  spinToWinLimit: spinToWinLimitSelector(state),
  isAdmin: state.loginReducer.isAdmin,
});

const mapDispatchToProps = {
  setSpinToWinLimit: startSpinToWinLimitFlow,
};

const SpinToWinSection = ({
  spinToWinLimit,
  isAdmin,
  setSpinToWinLimit,
}) => {
  const handleSetLimit = () => {
    setSpinToWinLimit({
      newSpinToWinOptions: {
        dailyLimit: spinToWinLimit,
      },
    });
  };

  return (
    <div className="col-lg-6">
      <Portlet config={{ title: 'Spin to Win' }}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="">
            <button
              className="bg-transparent btn btn-link text-reset font-weight-bold user-select-none"
              onClick={handleSetLimit}
              disabled={!isAdmin}
            >
              <u className="text-primary">
                <small>
                  {`Spin to Win Limit: ${spinToWinLimit || 'Not set'}`}
                </small>
              </u>
            </button>
          </div>
        </div>
      </Portlet>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SpinToWinSection);



// WEBPACK FOOTER //
// ./src/js/common/components/SpinToWinSection/index.jsx